import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth-sign-out',
  templateUrl: './auth-sign-out.component.html',
  styleUrls: ['./auth-sign-out.component.scss']
})
export class AuthSignOutComponent implements OnInit {

  error = false;
  loading = true;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    let all = this.route.snapshot.queryParams.all;
    this.authService.signOut(all).subscribe(
      (success) => {
        this.loading = false;
      },
      (error) => {
        this.error = true;
        this.loading = false;
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-sign-out.component.ts